import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class TransactionStatementsService {
    private readonly getTransactionStatementsURL = `/admin/transaction-statements`;

    // ---------------------------------------------------------------

    getTraceability(params: {
        size: number;
        page: number;
        serialNumber: string;
        ndcCode: string;
        fromDuns: string;
        toDuns: string;
        startDate: string;
        endDate: string;
    }) {
        return fetchWithRetry(API.get(this.getTransactionStatementsURL, { params }));
    }
}

export default new TransactionStatementsService();
